import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";
import PayType from "../../utilities/data/model/PayType";
import { useTranslation } from "react-i18next";

export type PayTypeIdToNameProps = TextPropTypes & {
  payTypeId: string;
};

export const PayTypeIdToName = ({
  payTypeId,
  ...props
}: PayTypeIdToNameProps) => {
  const { t } = useTranslation("common");
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const payType = await database
          .get<PayType>("pay_types")
          .find(payTypeId);

        setName(payType.name ?? t("unknown"));
      } catch (err) {
        setName(t("unknown"));
      }
    })();
  }, [payTypeId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
